import { Inject, Injectable } from '@angular/core';
import { Howl } from 'howler';


export class AudioList {
  name: string = '';
  fn: string = ''; // filename
}
@Injectable({
  providedIn: 'root',
})
export class AudioService {
  mp3_pristine: string = '/assets/audio/'+'pristine.mp3';
  public player!: Howl;
  private audioType = 'html5';
  private sounds: any = [];
  private soundList: AudioList[] = [];
  constructor() {
  }
  /*
  preload(fn: string) {
    this.sounds.clear();
    if (Capacitor.isNativePlatform()) {
      this.sounds.push(fn);//filename
    }else{
      this.sounds.push('/assets/audio/'+fn);//filename
    }
  }
  */
  play(fn:string) {
    this.sounds.length = 0;
    this.sounds.push(fn);//filename
    if(!this.player){
      //this.player = new Howl({ src: this.sounds, html5: true });
      this.player = new Howl({ src: this.sounds, html5: true });
    }
    this.player.play();
  }
  beep(count: number) {
    //audio.preload('pristine.mp3');
    //console.log('myBeep:',delaySec);

    for (let i = 0; i < count; i++) {
      //const audio = new AudioService('pristine.mp3');
      this.play(this.mp3_pristine);
      //await delay(delaySec*1000);
      //audio.player.pos(0);
    }
  }
}
